import { config } from '@/_helpers'
import axios from "axios"

let axiosHeaders = { 'Content-Type': 'application/json' }

export const $_app_server = axios.create({
  baseURL: config.apiUrl,
  headers: axiosHeaders
})